import { basicPath } from '../basicPath';

export const fetchMpCentersAll = (params) => async (dispatch) => {
    const path = '/mp-centers/all';
    const type = 'get';
    try {
        const response = await basicPath(dispatch, params, path, type);
        // Ensure we always return a response object with a status property
        // If basicPath returns {} (empty object), it means the request failed completely
        if (!response || typeof response !== 'object' || !response.hasOwnProperty('status')) {
            console.warn('[CENTERS] fetchMpCentersAll returned invalid/empty response, treating as 404:', response);
            return { status: 404, statusText: 'Not Found', data: null };
        }
        return response;
    } catch (error) {
        console.error('[CENTERS] fetchMpCentersAll error:', error);
        return { status: 404, statusText: 'Request Failed', data: null, error: error.message };
    }
}

export const fetchRpCentersAll = (params) => async (dispatch) => {
    const path = '/rp-centers/all';
    const type = 'get';
    try {
        console.log('[CENTERS] fetchRpCentersAll called with path:', path);
        const response = await basicPath(dispatch, params, path, type);
        console.log('[CENTERS] fetchRpCentersAll response:', {
            hasResponse: !!response,
            responseType: typeof response,
            status: response?.status,
            hasData: !!response?.data,
            dataType: typeof response?.data
        });
        // Ensure we always return a response object with a status property
        // If basicPath returns {} (empty object), it means the request failed completely
        if (!response || typeof response !== 'object' || !response.hasOwnProperty('status')) {
            console.warn('[CENTERS] fetchRpCentersAll returned invalid/empty response, treating as 404:', response);
            return { status: 404, statusText: 'Not Found', data: null };
        }
        return response;
    } catch (error) {
        console.error('[CENTERS] fetchRpCentersAll error:', error);
        return { status: 404, statusText: 'Request Failed', data: null, error: error.message };
    }
}